import _asyncToGenerator from "/portal/Vue/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/portal/Vue/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from "./routes";
import { i18n } from "../boot/i18n";
import { aftInst as aft } from 'boot/aft';
import { suGetServiceURL } from 'pages/access/signuputils';
Vue.use(VueRouter);

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default function /* { store, ssrContext } */
() {
  var Router = new VueRouter({
    scrollBehavior: function scrollBehavior() {
      return {
        x: 0,
        y: 0
      };
    },
    routes: routes,
    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE
  });
  Router.beforeEach(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(to, from, next) {
      var result, _result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(to.fullPath.indexOf('/signup?sid=') > -1)) {
              _context.next = 6;
              break;
            }
            _context.next = 3;
            return Vue.prototype.$aft.examAuthorization();
          case 3:
            result = _context.sent;
            if (result) {
              next(suGetServiceURL(to.query.sid, to.query.cur));
            } else {
              next();
            }
            return _context.abrupt("return");
          case 6:
            if (!(to.path === '/' || to.path === '/login' || to.path === '/signup' || to.path === '/$reauth$' || to.matched && to.matched.length > 1 && to.matched[0].path === '/auth')) {
              _context.next = 22;
              break;
            }
            _context.next = 9;
            return Vue.prototype.$aft.examAuthorization();
          case 9:
            _result = _context.sent;
            if (!_result) {
              _context.next = 18;
              break;
            }
            if (!(to.path === '/' || to.path === '/login' || to.path === '/signup' || to.path === '/$reauth$')) {
              _context.next = 14;
              break;
            }
            next({
              path: '/auth'
            }); // переходим на дефолтовую страницу.
            return _context.abrupt("return");
          case 14:
            aft.gotoPage(to, from);
            next();
            _context.next = 20;
            break;
          case 18:
            if (to.path !== '/' && to.path !== '/login' && to.path !== '/signup' && to.path !== '/$reauth$') {
              // Запоминаем страницу, на которую пользователь ломился, после авторизации отправим его туда.
              aft.g.auth.route = to;
              Vue.prototype.$aft.messageNegative(i18n.t('login.msg.toauth'));
            }
            if (to.path === '/login' || to.path === '/signup') {
              next();
            } else {
              next({
                path: '/login'
              });
            }
          case 20:
            _context.next = 23;
            break;
          case 22:
            next();
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }());

  // Router.afterEach((to, from) => {
  //   // Vue.prototype.$aft.finishInitpage()
  //   // console.log('Router.afterEach to: ' + to.path + '  from: ' + from.path)
  //   // // Vue.prototype.$i18n.locale = Vue.prototype.$aft.Lang;
  //   // i18n.locale = Vue.prototype.$aft.lang
  //   // console.log('After Router.afterEach lang: ' + Vue.prototype.$aft.lang)

  //   // console.log('to: ' + to.fullPath + ', from: ' + from.fullPath)
  //   // console.log(Vue.prototype.$aft.g.routeHistory)
  //   Vue.prototype.$aft.g.routeHistory = Vue.prototype.$aft.g.routeHistory || []
  //   // console.log(Vue.prototype.$aft.g.routeHistory)
  //   Vue.prototype.$aft.g.routeHistory.push(to)
  //   console.log(Vue.prototype.$aft.g.routeHistory)
  // })

  return Router;
}